import Pager from "./pager";

export default Pager;